import { combineReducers } from 'redux'
import businessReducer from 'modules/Business/reducer'
import userReducer from 'modules/User/reducer'
import uiReducer from 'modules/UI/reducer'
import { SESSION_CHANGED } from 'utils/session'

const combinedReducer = combineReducers({
  business: businessReducer,
  ui: uiReducer,
  user: userReducer,
})

const rootReducer = (state, action) => {
  if (action.type === SESSION_CHANGED) {
    state = {
      user: {
        location: state?.user.location,
        isFetching: action.hasToken,
        sessionGeneration: action.generation,
      },
    }
  }
  return combinedReducer(state, action)
}

export default rootReducer
